import { createPinia } from 'pinia';
import { createApp } from 'vue';
import App from './App.vue';
import { API_CLIENT_KEY, api } from './lib/api-client';
import { installUnauthorizedRedirect, router } from './router';
import './styles/main.css';

const app = createApp(App);

app.use(createPinia());
app.use(router);

/**
 * Provided explicitly even though `useApi()` falls back to this same
 * instance. The fallback exists so a component can be mounted alone in a
 * test; relying on it in the application would make the real wiring
 * invisible, and there would be nowhere to substitute a client.
 */
app.provide(API_CLIENT_KEY, api);

// Registered after the router exists, since it navigates. A 401 arriving
// mid-session - expired, or revoked because org membership lapsed - sends the
// user to the sign-in screen once rather than leaving a board full of
// components each failing on their own.
installUnauthorizedRedirect();

app.mount('#app');
